import {
  SET_OPTIONS_FORM_TAMBAH_MOBIL,
  SET_BOOKING_SERVICE_STATE,
  SET_FORM_BRANCH,
  SET_FORM_ADDRESS,
  SET_FORM_TIME,
  SET_IS_OPEN_MODAL_VEHICLE_INFORMATION,
  SET_INITIAL_STATE_FORM_VALUE,
  SET_INITIAL_FORM_BRANCH_TIME,
  SET_INIT_VALUE_CONFIRMATION_MODAL,
  RESET_ONE_STATE_SERVICES_STATE,
  RESET_STATE_SERVICES_STATE,
  RESET_ALL,
  RESET_STATE_BRANCH_TIME_STATE,
  SET_VISIBLE_GLOBAL_ERROR_MODAL,
  SET_STNK_EXPIRY_DATE,
  SET_DISPLAY_DETAIL_VOUCHER,
  SET_SHOW_TCARE_INFO_MODAL,
} from './constants';

const INITIAL_STATE = {
  formModalTambahMobil: {
    vehicleId: '',
    carModel: '',
    carType: '',
    carModelCode: '',
    productionYear: '',
    licencePlate: '',
    customer: '',
    transmission: '',
    isNewVehicle: false,
    vin: '',
  },
  stnkExpiryDate: '',
  carOptions: [],
  productionYearOptions: [],
  tipeMobilOptions: [],
  selectedCar: null,
  formBranchAddressTime: {
    branch: {
      name: '',
      code: '',
      address: '',
      cityCode: '',
    },
    address: {
      long: null,
      lat: null,
      address: '',
      detail: '',
      city: '',
      province: '',
      distance: '',
    },
    time: '',
  },
  modalMobileState: {
    isOpen: false,
    isTitle: '',
    typeModal: '',
    options: [],
    selectedOption: '',
  },

  // select car for choose car user login
  selectedChooseCar: null,
  isEditExistingCar: false,
  isEditNonLoginCar: false,
  openModalSelectVehicle: '',
  myVehicles: [],
  authData: null,
  isAccountSeamless: false,
  ConfirmationModalState: {
    visible: false,
    content: null,
    title: '',
    onClose: null,
    cancelButtonText: 'TUTUP',
    mobileModalHeightClassName: 'h-full',
  },
  programTCare: {
    jenisProgram: '',
    lastPMKM: 0,
    programDescription: '',
    endDate: '',
    endDateStatus: false,
  },
  isTCareActive: false,
  isExtendedWaranty: false,
  periodicList: [],
  generalRepairList: [],
  showDetailServiceBerkala: false,
  lastServiceVehicle: null,
  showLastServiceVehicle: false,
  servicesState: {
    periodicServiceChecked: false,
    selectedPeriodicService: null,
    generalRepairChecked: false,
    selectedGeneralServices: [],
    selectedOpl: [],
    otherServiceChecked: false,
    otherService: '',
    selectedOplOps: [],
    selectedGeneralRepairs: [],
  },
  visibleGlobalError: false,
  showDetailVoucherGift: false,
  showTCareInfoModal: false,
};

const reducer = (state = INITIAL_STATE, action: { type: string; payload: any }) => {
  switch (action.type) {
    case SET_OPTIONS_FORM_TAMBAH_MOBIL:
      return {
        ...state,
        [action.payload.field]: action.payload.options,
      };
    case SET_INITIAL_STATE_FORM_VALUE:
      return {
        ...state,
        formModalTambahMobil: {
          vehicleId: '',
          carModel: '',
          carType: '',
          carModelCode: '',
          productionYear: '',
          licencePlate: '',
          customer: '',
          transmission: '',
          isNewVehicle: false,
          vin: '',
        },
      };
    case SET_STNK_EXPIRY_DATE:
      return {
        ...state,
        stnkExpiryDate: action.payload,
      };
    case SET_BOOKING_SERVICE_STATE:
      return {
        ...state,
        [action.payload.field]: action.payload.value,
      };
    case SET_FORM_BRANCH:
      return {
        ...state,
        formBranchAddressTime: {
          ...state.formBranchAddressTime,
          branch: {
            ...state.formBranchAddressTime.branch,
            [action.payload.field]: action.payload.value,
          },
        },
      };
    case SET_FORM_ADDRESS:
      return {
        ...state,
        formBranchAddressTime: {
          ...state.formBranchAddressTime,
          address: {
            ...state.formBranchAddressTime.address,
            [action.payload.field]: action.payload.value,
          },
        },
      };
    case SET_FORM_TIME:
      return {
        ...state,
        formBranchAddressTime: {
          ...state.formBranchAddressTime,
          time: action.payload,
        },
      };
    case SET_IS_OPEN_MODAL_VEHICLE_INFORMATION:
      return {
        ...state,
        openModalSelectVehicle: action.payload.value,
      };
    case SET_INITIAL_FORM_BRANCH_TIME:
      return {
        ...state,
        formBranchAddressTime: action.payload,
      };
    case SET_INIT_VALUE_CONFIRMATION_MODAL:
      return {
        ...state,
        ConfirmationModalState: {
          visible: false,
          content: null,
          title: '',
          mobileModalHeightClassName: 'h-full',
          onClose: () => {},
          cancelButtonText: 'TUTUP',
        },
      };
    case RESET_ONE_STATE_SERVICES_STATE:
      return {
        ...state,
        servicesState: {
          ...state.servicesState,
          [action.payload.field]: action.payload.value,
        },
      };
    case RESET_STATE_SERVICES_STATE:
      return {
        ...state,
        servicesState: {
          periodicServiceChecked: false,
          selectedPeriodicService: null,
          generalRepairChecked: false,
          selectedGeneralServices: [],
          selectedOpl: [],
          selectedOplOps: [],
          selectedGeneralRepairs: [],
          otherServiceChecked: false,
          otherService: '',
        },
      };
    case RESET_STATE_BRANCH_TIME_STATE:
      return {
        ...state,
        formBranchAddressTime: {
          branch: {
            name: '',
            code: '',
            address: '',
            cityCode: '',
          },
          address: {
            long: null,
            lat: null,
            address: '',
            detail: '',
            city: '',
            province: '',
          },
          time: '',
        },
      };
    case RESET_ALL:
      return INITIAL_STATE;
    case SET_VISIBLE_GLOBAL_ERROR_MODAL:
      return {
        ...state,
        visibleGlobalError: action.payload,
      };
    case SET_DISPLAY_DETAIL_VOUCHER:
      return {
        ...state,
        showDetailVoucherGift: action.payload,
      };
    case SET_SHOW_TCARE_INFO_MODAL:
      return {
        ...state,
        showTCareInfoModal: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
